import React from 'react';
import '../styles/process.page.scss';
import { Container, Row, Col, Image } from 'react-bootstrap';
import PageTitle from '../components/PageTitle';

export default function Team({ l }) {
    return (
        <Container>
            <PageTitle title={l.pageTitle} />
            <Row className="mt-n3">
                <Col xs={12}>
                    <h2 className="h3">{l.judgeTitle}</h2>
                </Col>
                {renderPartners(l.judges)}
            </Row>
            {/* <hr className="my-3 my-md-5" />
            <Row className="mt-n3">
                <Col xs={12}>
                    <h2 className="h3">{l.partnerTitle}</h2>
                </Col>
                {renderPartners(l.partners)}
            </Row> */}
            <hr className="my-3 my-md-5" />
            <Row className="mt-n3">
                <Col xs={12}>
                    <h2 className="h3">{l.cityPartnerTitle}</h2>
                </Col>
                {renderPartners(l.cityPartners, true)}
            </Row>
            {l.supporters &&
                <>
                    <hr className="my-3 my-md-5" />
                    <Row className="mt-n3">
                        <Col xs={12}>
                            <h2 className="h3">{l.supportersTitle}</h2>
                        </Col>
                        {renderSupporters(l.supporters, true)}
                    </Row>
                </>
            }
        </Container>
    )
}

// function renderProfile(profile, i) {
//     return (
//         <Col xs={12} md={6} lg={4} className="mt-5" key={`profile-${i}`}>
//             <div>
//                 <Image fluid className="w-100" src={profile.photoSrc} alt={profile.photoAlt} />
//             </div>
//             <div className="mt-1 mt-md-3">
//                 <p className="h5 mb-0">{profile.name}</p>
//             </div>
//             <div>
//                 <p className="font-italic">{profile.title}</p>
//             </div>
//         </Col>
//     )
// }

// function renderCityPartners(partners) {
//     return (
//         <Row className="p-2 pb-5 w-100 d-flex justify-content-center">
//             {partners.map((partner, i) => (
//                 <Col xs={4} md="auto" className="align-top">
//                     <Image fluid src={partner.photoSrc} alt={partner.photoAlt} />
//                 </Col>
//             ))}
//         </Row>
//     )
// }

function renderPartners(partners, isCenter) {
    return (
        <Row className="p-2 pb-5 w-100 d-flex justify-content-around justify-content-md-between">
            {partners.map((partner, i) => (
                <Col xs={12} md={4} className={isCenter ? "d-flex justify-content-center align-self-center" : ""}>
                    <Image fluid src={partner.photoSrc} alt={partner.photoAlt} style={{ maxWidth: '240px', maxHeight: '120px' }} />
                    <p className="mt-2">{partner.description}</p>
                </Col>
            ))}
        </Row>
    )
}
function renderSupporters(supporters, isCenter) {
    return (
        <Row className="p-2 pb-5 w-100 d-flex justify-content-around justify-content-md-between">
            {supporters.map((supporter, i) => (
                <Col xs={12} md={4} className={isCenter ? "d-flex flex-column justify-content-center align-items-center text-center" : ""}>
                    <div>
                        <span className="h4 bold">{supporter.name}</span>
                    </div>
                    {supporter.description &&
                        <div className="text-center">
                            <p dangerouslySetInnerHTML={{__html: supporter.description}}></p>
                        </div>
                    }
                </Col>
            ))}
        </Row>
    )
}


